<template>
    <div id="chartdiv" v-if="chartData"></div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import * as am4plugins_sunburst from '@amcharts/amcharts4/plugins/sunburst'

am4core.useTheme(am4themes_animated)

export default {
	name: 'sunburst-chart',
	props: {
		chartData: Array,
	},

	data() {
		return {
			chart: null,
		}
	},

	mounted() {
		this.initialize()
	},


	methods: {

		initialize() {
			if (this.chart) {
				this.chart.dispose()
			}

			this.chart = am4core.create('chartdiv', am4plugins_sunburst.Sunburst)
			this.chart.padding(0,0,0,0)
			this.chart.radius = am4core.percent(98)
			this.chart.data = this.chartData


			this.chart.colors.step = 2
			this.chart.fontSize = 11
			this.chart.innerRadius = am4core.percent(10)

			// define data fields
			this.chart.dataFields.value = 'revenue'
			this.chart.dataFields.name = 'category_name'
			this.chart.dataFields.children = 'subcategories'


			let level0SeriesTemplate = new am4plugins_sunburst.SunburstSeries()
			level0SeriesTemplate.hiddenInLegend = false
			this.chart.seriesTemplates.setKey('0', level0SeriesTemplate)

			// this makes labels to be hidden if they don't fit
			level0SeriesTemplate.labels.template.truncate = true
			level0SeriesTemplate.labels.template.hideOversized = true

			level0SeriesTemplate.labels.template.adapter.add('rotation', (rotation, target) =>  {
				target.maxWidth = target.dataItem.slice.radius - target.dataItem.slice.innerRadius - 10
				target.maxHeight = Math.abs(target.dataItem.slice.arc * (target.dataItem.slice.innerRadius + target.dataItem.slice.radius) / 2 * am4core.math.RADIANS)

				return rotation
			})


			let level1SeriesTemplate = level0SeriesTemplate.clone()
			this.chart.seriesTemplates.setKey('1', level1SeriesTemplate)
			level1SeriesTemplate.fillOpacity = 0.75
			level1SeriesTemplate.hiddenInLegend = true

			let level2SeriesTemplate = level0SeriesTemplate.clone()
			this.chart.seriesTemplates.setKey('2', level2SeriesTemplate)
			level2SeriesTemplate.fillOpacity = 0.5
			level2SeriesTemplate.hiddenInLegend = true

			this.chart.legend = new am4charts.Legend()

		},
	},

	watch: {
		chartData: {
			handler() {
				this.initialize()
			},
			deep: true
		},
	},

	beforeDestroy() {
		if (this.chart) {
			this.chart.dispose()
		}
	},        
}
</script>

<style>
	g[opacity|="0.4"][aria-labelledby|="id"] {
  		display: none;
	}
    
    #chartdiv {
        min-height: 800px
    }
</style>
